import Vue from 'vue';

Vue.filter('initials', (name) => {
  if (!name) {
    return '';
  }
  const chunks = name.split(' ');
  if (chunks.length > 1) return chunks[0].charAt(0) + chunks[1].charAt(0);
  return name.substr(0, 2).toUpperCase();
});
// highlight filter
Vue.filter('highlight', (words, query) => {
  if (query) {
    const iQuery = new RegExp(query, 'ig');
    return words?.toString().replace(iQuery, (matchedTxt) => `<mark> ${matchedTxt} </mark>`);
  }
  return words;
});
